import {createAsyncThunk, createSlice, PayloadAction} from '@reduxjs/toolkit';

import {apiRequestGetMemberInfo} from "../../api/apiRequests";
import {checkRedirect} from "../login/RequireAuth";
import {NavigateFunction} from "react-router-dom";

export interface MemberFile {
  fileName: string,
  link?: string,
  uploaded?: boolean,
}
export interface MemberFilesState {
  processingFiles: MemberFile[],
  editedFiles: MemberFile[],
  filesStatus: string,
  filesUpdateStatus: string,
}

const initialState: MemberFilesState = {
  processingFiles: [],
  editedFiles: [],
  filesStatus: "loading",
  filesUpdateStatus: "",
}

export const fetchFiles = createAsyncThunk(
  'files/get',
  async (params: {navigate: NavigateFunction}) => {
    const response = await apiRequestGetMemberInfo();
    await checkRedirect(params, response);
    return (typeof response === "object" && response.name === "AxiosError") ? {} : response
  },
)
export const updateFiles = createAsyncThunk(
  'files/update',
  async (params: {navigate: NavigateFunction}) => {
    const response = await apiRequestGetMemberInfo();
    await checkRedirect(params, response);
    return (typeof response === "object" && response.name === "AxiosError") ? {} : response
  },
)

export const memberFilesSlice = createSlice({
  name: 'memberFiles',
  initialState,
  reducers: {
    // increment: (state) => {
    //   // Redux Toolkit allows us to write "mutating" logic in reducers. It
    //   // doesn't actually mutate the state because it uses the Immer library,
    //   // which detects changes to a "draft state" and produces a brand new
    //   // immutable state based off those changes
    //   state.value += 1
    // },
    // decrement: (state) => {
    //   state.value -= 1
    // },
    // incrementByAmount: (state, action: PayloadAction<number>) => {
    //   state.value += action.payload
    // },
    setUploadedFiles: (state, action: PayloadAction<MemberFile[]>) => {
      console.log("state", state);
      console.log("action", action);
      state.editedFiles = action.payload
    },
  },
  extraReducers(builder) {
    builder
      .addCase(fetchFiles.pending, (state) => {
        state.filesStatus = "loading"
      })
      .addCase(fetchFiles.fulfilled,
        (
          state,
         action:PayloadAction<{editedFiles: MemberFile[], processingFiles: MemberFile[]}>
        ) => {
        state.filesStatus = "succeeded";
        if (typeof action.payload === "object" && (action.payload !== null)) {
          if (Array.isArray(action.payload.editedFiles)) {
            state.editedFiles = action.payload.editedFiles;
          }
          if (Array.isArray(action.payload.processingFiles)) {
            state.processingFiles = action.payload.processingFiles;
          }
        }
      })
      .addCase(fetchFiles.rejected, (state) => {
        state.filesStatus = "failed"
      })
      .addCase(updateFiles.pending, (state) => {
        state.filesUpdateStatus = "loading"
      })
      .addCase(updateFiles.fulfilled,
        (
          state,
          action:PayloadAction<{editedFiles: MemberFile[], processingFiles: MemberFile[]}>
        ) => {
          state.filesUpdateStatus = "succeeded";
          if (typeof action.payload === "object" && (action.payload !== null)) {
            if (Array.isArray(action.payload.editedFiles)) {
              state.editedFiles = action.payload.editedFiles;
            }
            if (Array.isArray(action.payload.processingFiles)) {
              state.processingFiles = action.payload.processingFiles;
            }
          }
        })
      .addCase(updateFiles.rejected, (state) => {
        state.filesUpdateStatus = "failed"
      })
  }
});

export const { setUploadedFiles } = memberFilesSlice.actions;

export default memberFilesSlice.reducer